"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StatesRepository = /** @class */ (function () {
    function StatesRepository($resource) {
        return $resource('/Umbraco/api/states/:action/:id', null, {
            'get': { method: 'GET', isArray: true, params: { action: 'Get' } }
        });
    }
    return StatesRepository;
}());
exports.StatesRepository = StatesRepository;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdGVzLmFwaS5mYWN0b3J5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic3RhdGVzLmFwaS5mYWN0b3J5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUE7SUFDSSwwQkFBWSxTQUFTO1FBQ2pCLE9BQU8sU0FBUyxDQUFDLGlDQUFpQyxFQUFFLElBQUksRUFBRTtZQUN0RCxLQUFLLEVBQUUsRUFBQyxNQUFNLEVBQUUsS0FBSyxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLEVBQUMsTUFBTSxFQUFFLEtBQUssRUFBQyxFQUFDO1NBQ2pFLENBQUMsQ0FBQztJQUNQLENBQUM7SUFDTCx1QkFBQztBQUFELENBQUMsQUFORCxJQU1DO0FBTlksNENBQWdCIn0=